// src/Components/Alerts/SlotCountdownInline.jsx
import React, { useEffect, useState } from 'react';
import { Badge, Tooltip } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import moment from 'moment-timezone';

const SlotCountdownInline = () => {
  const [left, setLeft] = useState(null);
  const [expiresLocal12, setExpiresLocal12] = useState('');

  useEffect(() => {
    const raw = localStorage.getItem('bookingExpiresAt'); // "HH:mm:ss" UK
    if (!raw) return;

    // const uk = moment.tz(raw, 'HH:mm:ss', 'Europe/London');
    // const local = uk.clone().tz(moment.tz.guess());

    // console.log("printing remaning time", raw)
    const parts = raw.split(':');
    const minutes = parseInt(parts[0], 10);
    const seconds = parseInt(parts[1], 10);
    const millis  = parseInt(parts[2], 10);

    const uk = moment.duration({
        minutes,
        seconds,
        milliseconds: millis
      });;

    const local = moment().add(uk);
    setExpiresLocal12(local.format('hh:mm:ss A'));
    // console.log("printing remaning time after", local.format('hh:mm:ss A'),"and",uk)
    
    const tick = () => {
      const diff = local.diff(moment());
      setLeft(diff > 0 ? diff : null);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  if (left === null) return null;

  return (
    <Tooltip title={`Expires at ${expiresLocal12}`}>
    <div style={{ display: 'flex', alignItems: 'center' , cursor: 'pointer'}}>
      <Badge
        count={moment.utc(left).format('mm:ss')}
        color="#008385"
        style={{ fontSize: 14, marginRight: 6 }}
      />
      <ClockCircleOutlined style={{ fontSize: 20, color: '#008385' }} />
      </div>
    </Tooltip>
  );
};

export default SlotCountdownInline;